/* Custom Press Quote — rotating testimonial carousel (fade, dots, arrows, play/pause, autoplay). */
class PressQuoteSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.press-quote__slide'));
    this.dots = Array.from(this.querySelectorAll('.press-quote__dot'));
    this.count = this.slides.length;
    if (this.count === 0) return;

    this.index = 0;
    this.timer = null;
    this.playing = false;
    this.speed = parseInt(this.dataset.speed || '5000', 10);
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.prevBtn = this.querySelector('[data-pq-prev]');
    this.nextBtn = this.querySelector('[data-pq-next]');
    this.playBtn = this.querySelector('[data-pq-play]');

    this.onPrev = () => { this.go(this.index - 1); this.restartIfPlaying(); };
    this.onNext = () => { this.go(this.index + 1); this.restartIfPlaying(); };
    this.onDot = (e) => { this.go(parseInt(e.currentTarget.dataset.to, 10)); this.restartIfPlaying(); };
    this.onToggle = () => (this.playing ? this.pause() : this.play());
    this.onEnter = () => { if (this.playing) this.clearTimer(); };
    this.onLeave = () => { if (this.playing) this.startTimer(); };

    this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
    this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
    this.dots.forEach((d) => d.addEventListener('click', this.onDot));
    this.playBtn && this.playBtn.addEventListener('click', this.onToggle);
    this.addEventListener('mouseenter', this.onEnter);
    this.addEventListener('mouseleave', this.onLeave);

    this.go(0);

    if (this.dataset.autoplay === 'true' && this.count > 1 && !this.reduceMotion) {
      this.play();
    } else {
      this.updatePlayBtn();
    }
  }

  go(i) {
    this.index = (i + this.count) % this.count;
    this.slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
    this.dots.forEach((d, n) => {
      const active = n === this.index;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  startTimer() {
    this.clearTimer();
    this.timer = setInterval(() => this.go(this.index + 1), this.speed);
  }
  clearTimer() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }
  restartIfPlaying() { if (this.playing) this.startTimer(); }

  play() { this.playing = true; this.startTimer(); this.updatePlayBtn(); }
  pause() { this.playing = false; this.clearTimer(); this.updatePlayBtn(); }

  updatePlayBtn() {
    if (!this.playBtn) return;
    this.playBtn.classList.toggle('is-playing', this.playing);
    this.playBtn.setAttribute('aria-pressed', this.playing ? 'true' : 'false');
    this.playBtn.setAttribute('aria-label', this.playing ? 'Pause' : 'Play');
  }

  disconnectedCallback() {
    this.clearTimer();
    this.prevBtn && this.prevBtn.removeEventListener('click', this.onPrev);
    this.nextBtn && this.nextBtn.removeEventListener('click', this.onNext);
    this.dots.forEach((d) => d.removeEventListener('click', this.onDot));
    this.playBtn && this.playBtn.removeEventListener('click', this.onToggle);
    this.removeEventListener('mouseenter', this.onEnter);
    this.removeEventListener('mouseleave', this.onLeave);
  }
}

if (!customElements.get('press-quote-slider')) {
  customElements.define('press-quote-slider', PressQuoteSlider);
}
